module.exports = __webpack_public_path__ + "img/mob-profile.a1ecd51a.svg";